import { render, staticRenderFns } from "./overview-main-card-expandable-row.component.vue?vue&type=template&id=1adea09b&scoped=true&"
import script from "./overview-main-card-expandable-row.component.vue?vue&type=script&lang=ts&"
export * from "./overview-main-card-expandable-row.component.vue?vue&type=script&lang=ts&"
import style0 from "./overview-main-card-expandable-row.component.vue?vue&type=style&index=0&id=1adea09b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adea09b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VDataTable,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})
